<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    style="enable-background: new 0 0 100 100"
    viewBox="0 0 100 100">
    <path
      d="M8.78 43.71H8.7c-3.47 0-6.29 2.82-6.29 6.29s2.82 6.29 6.29 6.29h82.6c3.47 0 6.29-2.82 6.29-6.29s-2.82-6.29-6.29-6.29H8.78z"
      style="fill: #1b3d6f" />
    <path
      d="M56.29 8.78V8.7c0-3.47-2.82-6.29-6.29-6.29s-6.29 2.82-6.29 6.29v82.6c0 3.47 2.82 6.29 6.29 6.29s6.29-2.82 6.29-6.29V8.78z"
      style="fill: #1b3d6f" />
  </svg>
</template>
